"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useElementSize = void 0;
const react_1 = require("react");
const resize_observer_1 = __importDefault(require("@react-hook/resize-observer"));
const useElementSize = (ref) => {
    const [size, setSize] = (0, react_1.useState)({ height: 0, width: 0 });
    const setSizeIfDifferent = (newSize) => {
        if (newSize.height === size.height && newSize.width === size.width)
            return;
        setSize(newSize);
    };
    (0, react_1.useLayoutEffect)(() => {
        if (!ref.current) {
            setSizeIfDifferent({ height: 0, width: 0 });
        }
        else {
            const { height, width } = ref.current.getBoundingClientRect();
            setSizeIfDifferent({ height, width });
        }
    }, [ref.current]);
    (0, resize_observer_1.default)(ref, (entry) => {
        const { height, width } = entry.contentRect;
        setSizeIfDifferent({ height, width });
    });
    return size;
};
exports.useElementSize = useElementSize;
//# sourceMappingURL=useElementSize.js.map